import React from "react";
import customConfig from "../../config";
import { updateEmailIDbyUserID } from "../../action/user";
import { connect } from "react-redux";
import UserInfoWrapper from "../Common/user/UserInfoWrapper";
import FormInput from "../Common/FormInputs/MuiTextField";
import AppButton from "../Common/Button/Button";
import AppIconButton from "../Common/Button/IconButton";
import { Box, Paper, Stack } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import EditIcon from "@mui/icons-material/Edit";
import { SectionHeading, LabelText, ValueText } from "../Common/Typography/AppTypography";

function UserInfo(props) {
  const userById = props.user;
  const withoutOnboard = props?.withoutOnboard ?? false;
  // const [showUpdateEmailID, setShowUpdateEmailID] = useState(false);
  // const [disabledEmailUpdateButton, setDisabledEmailUpdateButton] = useState(false);
  // const [emailValidationMessage, setEmailValidationMessage] = useState(false);
  // let [userEmailId, setUserEmailId] = useState(user && user.email ? user.email : "");
  // const userRoleInfo = useContext(UserContext);

  // useEffect(() => {
  //   if (emailUpdateError) {
  //     cancelEmailPopup();
  //   }
  // }, [emailUpdateError]);

  // useEffect(() => {
  //   if (emailUpdateSuccess) {
  //     user.email = userEmailId;
  //   }
  // }, [emailUpdateSuccess]);

  // // Visible email update form
  // const showUpdateEmailPopup = () => {
  //   setDisabledEmailUpdateButton(userEmailId.length <= 0);
  //   setShowUpdateEmailID(!showUpdateEmailID);
  // }

  // const cancelEmailPopup = () => {
  //   setUserEmailId(user && user.email ? user.email.trim() : "");
  //   setShowUpdateEmailID(false);
  //   setDisabledEmailUpdateButton(false);
  //   setEmailValidationMessage(false);
  // }

  // // Hit api to update email id
  // const updateEmailIdClick = () => {
  //   const updatedEmailID = userEmailId.trim();
  //   const isValid = (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(updatedEmailID));
  //   if (!isValid) {
  //     setEmailValidationMessage(true);
  //     return;
  //   }
  //   setEmailValidationMessage(false);
  //   updateEmailIDbyUserID(user.userId, updatedEmailID);
  //   setShowUpdateEmailID(false);
  // }

  // const onChange = (e) => {
  //   if (e.target.value.trim().length > 0)
  //     setDisabledEmailUpdateButton(false);
  //   else
  //     setDisabledEmailUpdateButton(true);

  //   setUserEmailId(e.target.value);
  // };

  return (
    <UserInfoWrapper userById={userById} withoutOnboard={withoutOnboard}>
      {({
        showUpdateEmailID,
        disabledEmailUpdateButton,
        emailValidationMessage,
        userRoleInfo,
        showUpdateEmailPopup,
        cancelEmailPopup,
        updateEmailIdClick,
        onChange,
        user,
        userEmailId,
      }) => (
        <Paper elevation={2} sx={{ p: 2, borderRadius: 1, mb: 1.875 }}>
          <SectionHeading sx={{ mb: 1.5 }}>
            User Information
          </SectionHeading>
          {user && user.userName && withoutOnboard === false ? (
            <Box sx={{ mt: 1 }}>
              <Grid2 container spacing={{ xs: 1.25, sm: 2 }} alignItems="flex-start">
                <Grid2 size={{ xs: 12, md: 4 }}>
                  <Stack
                    spacing={{ xs: 0.35, sm: 0.75 }}
                    sx={{ minHeight: { xs: "auto", md: 88 }, justifyContent: "flex-start" }}
                  >
                    <LabelText sx={{ fontSize: 13 }}>Name</LabelText>
                    <ValueText sx={{ fontSize: 15, lineHeight: 1.25 }}>
                      {user.firstName} {user.lastName}
                    </ValueText>
                  </Stack>
                </Grid2>

                <Grid2 size={{ xs: 12, md: 4 }}>
                  <Stack
                    spacing={{ xs: 0.35, sm: 0.75 }}
                    sx={{ minHeight: { xs: "auto", md: 88 }, justifyContent: "flex-start" }}
                  >
                    <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mb: 0.25 }}>
                      <LabelText sx={{ fontSize: 13 }}>Email Id</LabelText>
                      {userRoleInfo.level > 1 && !showUpdateEmailID && (
                        <AppIconButton
                          size="small"
                          variant="ghost"
                          onClick={showUpdateEmailPopup}
                          icon={<EditIcon fontSize="small" />}
                          tooltip="Edit email"
                          aria-label="Edit email"
                          sx={{ p: 0.5 }}
                        />
                      )}
                    </Stack>
                    {!showUpdateEmailID && (
                      <ValueText sx={{ fontSize: 15 }}>
                        {userEmailId}
                      </ValueText>
                    )}

                    {showUpdateEmailID && (
                      <Stack spacing={1.25} sx={{ maxWidth: 320 }}>
                        <FormInput
                          id="dashboard-user-email-update"
                          type="text"
                          name="dashboard-user-email-update"
                          placeholder="Enter Email Id"
                          value={userEmailId}
                          onChange={onChange}
                          size="small"
                          fullWidth
                          error={Boolean(emailValidationMessage)}
                          helperText={emailValidationMessage ? "Email is not valid" : ""}
                          touched="true"
                        />
                        <Stack direction="row" spacing={1}>
                          <AppButton
                            disabled={disabledEmailUpdateButton}
                            type="submit"
                            variant="primary"
                            size="small"
                            onClick={() => updateEmailIdClick()}
                          >
                            Update
                          </AppButton>
                          <AppButton
                            variant="ghost"
                            size="small"
                            onClick={() => cancelEmailPopup()}
                          >
                            Cancel
                          </AppButton>
                        </Stack>
                      </Stack>
                    )}
                  </Stack>
                </Grid2>

                <Grid2 size={{ xs: 12, md: 4 }}>
                  <Stack
                    spacing={{ xs: 0.35, sm: 0.75 }}
                    sx={{ minHeight: { xs: "auto", md: 88 }, justifyContent: "flex-start" }}
                  >
                    <LabelText sx={{ fontSize: 13 }}>Phone Number</LabelText>
                    <ValueText sx={{ fontSize: 15, lineHeight: 1.25 }}>
                      {user.mobile}
                    </ValueText>
                  </Stack>
                </Grid2>
              </Grid2>
            </Box>
          ) : (
            <LabelText sx={{ textAlign: "center", display: "block" }}>
              {withoutOnboard ? customConfig.noOnboardMsg : customConfig.noDataMsg}
            </LabelText>
          )}
        </Paper>
      )}
    </UserInfoWrapper>
  );
}

const mapStateToProps = (state) => ({
  UserData: state.user,
});

export default connect(mapStateToProps, { updateEmailIDbyUserID })(UserInfo);
